import React from 'react';
import {colorSchemes} from "./ColorSchemes.jsx";
import * as styles from "./styles/styles.jsx"
class NavBar extends React.Component {
   
   constructor(props)
   {
      super(props);
      this.depth = props.depth ? props.depth : 0;
      this.backgroundColor = colorSchemes.btn[this.depth];
      this.inactiveColor = colorSchemes.btn[this.depth] + 1;
      this.activeColor =  colorSchemes.btn[this.depth + 2];

      var s1:string;

      s1 = null;
   }
	
   render() {
      var navBarStyle = {
         //background: this.backgroundColor,
         //margin: 0,
         //listStyle: 'none',
         //height:24,
         //border: "1px solid green",
         //paddingRight: window.innerWidth * styles.edgePadFactor,
         //paddingLeft: window.innerWidth * styles.edgePadFactor,
         //position:"absolute",
         //top:0, bottom:0,left:0, right:0,
         height:"100%",
         verticalAlign: "middle",

      }  
      //console.log("Render Nav BAr");


      return (
         <div style = {navBarStyle}>
            {this.props.btns.map((btn, i) => 
            this.props.navBarState.visibleBtns && !this.props.navBarState.visibleBtns.has(btn.id) ? null :
            <NavBtn key = {i} data = {btn} isCurrent = {btn.id == this.props.navBarState.currentBtn}
            cB = {this.props.appCallbacks.changePageCallback} depth = {this.depth}/>, this)}
         </div>
         
         );
   }
}

export default NavBar;

class NavBtn extends React.Component
{
  constructor(props)
  {
      super(props);
      
      this.depth = props.depth ? props.depth : 0;
      this.inactiveColor = colorSchemes.btn[this.depth + 1];
      this.activeColor =  colorSchemes.btn[this.depth + 2];

      this.cB = function()
      {
         this.props.cB(this.props.data.id);
      }.bind(this);
  }
   render() {

      var btnStyle = {
         textAlign: this.props.data.floatRight ? 'right' : 'left',
         float: this.props.data.floatRight ? 'right' : 'left',
         height:'50%',
         color: !this.props.isCurrent ? "#DDD" : "#FFF",
         cursor: this.props.isCurrent ? "default" : "pointer",
         //border: "1px solid",
         //width: "20%",
         //fontWeight: "bold",
         //fontSize: "100%",
         //lineHeight:"100%",
      }
      return (
         /*<li style={btnStyle} ><button onClick = {this.cB}>{this.props.data.name}</button></li>*/
         <a className="navBarBtn" style={btnStyle} onClick = {this.cB}>{this.props.data.name}</a>
      )
   }
}


// WEBPACK FOOTER //
// ./js/NavBar.jsx